export default __webpack_public_path__ + "f9d7e835a19dce322233be9dbe9f7340.png";